import { Environment } from "./Environment";

export const Develop = new Environment("develop", {
  debug: true,
  apiBase: "https://api.develop.serverready.io",
  appBasePath: "https://app.develop.serverready.io",
  appDomain: "app.develop.serverready.io",
  cookieDomain: ".develop.serverready.io",
});
